import React from 'react';

const FaqList = () => {
  return (
    <div className='faq__list'>
      <div className='item'>
        <div className='item__header'>
          <h4>Chuyển đổi số vì sao lại cần ?</h4>
          <time>Sep 19 - 2020</time>
          <p>
            Chuyển đổi số không chỉ giúp tăng năng suất, giảm chi phí mà còn mở
            ra không gian phát triển mới, tạo ra các giá trị mới ngoài các giá
            trị truyền thống vốn có.
          </p>
        </div>
        <div className='item__content'>
          <p>Kinh tế số đem lại lợi ích gì cho người dân?</p>
          <p>
            Kinh tế số cho phép mỗi người dân có thể tiếp cận toàn bộ thị trường
            một cách nhanh chóng theo cách chưa từng có. Nếu như trước đây,
            người dân mang hàng ra chợ bán thì chỉ tiếp cận được vài chục đến
            vài trăm người trong khu vực địa lý hạn chế của mình. Còn hiện nay,
            với thương mại điện tử, người dân có thể bán hàng cho hàng triệu
            người, trên toàn thế giới.
          </p>
          <p>
            Mỗi người dân với một chiếc điện thoại thông minh, mỗi hộ gia đình
            một đường cáp quang, là có thể trở thành một doanh nghiệp, là có thể
            tiếp cận cả thế giới. Ngư dân trong quá khứ vẫn thường mang số cá họ
            đánh bắt được hàng ngày ra chợ và ngồi nhìn chúng hư thối đi vào
            cuối ngày khi không có người mua, giờ đây, họ có thể giữ cá ở dưới
            sông và đợi cho khách hàng gọi điện. Một khi nhận được đơn hàng qua
            mạng, cá được lấy ra khỏi nước và chuẩn bị bán cho khách hàng. Hệ
            thống bưu chính, chuyển phát sẽ giao hàng tới tận tay người mua.
            Không cần phải mua một chiếc tủ đông lạnh, không còn rủi ro bán cá
            ươn với giá thấp có thể gây ngộ độc cho khách hàng và sẽ giảm cả
            tình trạng đánh bắt cá quá mức cần thiết.
            <br />
            Để tìm hiểu thêm về chuyển đổi số, hãy tham khảo ở đây:{' '}
            <a
              href='https://dx.mic.gov.vn/docs/chuyen-doi-so-la-gi/'
              target='_blank'
            >
              Chuyển đổi số
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FaqList;
